import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["alignWithText", "size", "titleText"];
import { LockedIcon } from 'foundations-assets';
import { View } from '../../../components/View';
import { toShorthandSize } from '../../utils/tShirtSizes';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const mapSizeToIconSize = {
  xs: '100',
  // 12px
  sm: '300',
  // 16px (matches 'small': 16px)
  md: '800',
  // 32px (matches 'medium': 32px)
  lg: '900',
  // 48px (matches 'large': 48px)
  xl: '1200' // 96px
};
export const LockBadge = _ref => {
  let {
      alignWithText,
      size = 'small',
      titleText = I18n.text('salesUI.UILockBadge.title')
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const shortSize = typeof size === 'string' ? toShorthandSize(size) : size;
  const iconSize = typeof shortSize === 'string' && shortSize in mapSizeToIconSize ? mapSizeToIconSize[shortSize] : size;
  return /*#__PURE__*/_jsx(View, Object.assign({}, rest, {
    as: "span",
    display: "inline-block",
    children: /*#__PURE__*/_jsx(LockedIcon, {
      alignWithText: alignWithText,
      "aria-label": titleText,
      size: iconSize
    })
  }));
};